import React from "react";
import { Link } from "react-router-dom";
import ReactTooltip  from "react-tooltip";


export const LinktoSelect = () => {
  return (
    <>
      <Link to="/select" data-tip="選択画面">
        <ReactTooltip 
          effect="float"
          type="info"
          place="right"
          delayShow={1000}
        />
        <svg
          className="w-6 h-6 mx-auto"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
          />
        </svg>
      </Link>
    </>
  );
};